module.exports = __webpack_public_path__ + "img/embedded.391c7cb1.svg";